import React, { useState, useRef, useEffect } from 'react';
import '../Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Handle clicking outside to close menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Close menu when navigating
  const handleNavClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="site-header">
      <div className="site-nav-background" aria-hidden="true"></div>

      <div className="site-nav-inner">
        <a href="/" className="site-home-link" onClick={handleNavClick} aria-label="Home">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M3 9L12 2L21 9V21H3V9Z" stroke="currentColor" strokeWidth="1.2" opacity="1"/>
            <path d="M5 10.5L12 4.5L19 10.5V19H5V10.5Z" stroke="currentColor" strokeWidth="1.1" opacity="0.75"/>
            <path d="M7 12L12 7L17 12V17H7V12Z" stroke="currentColor" strokeWidth="1" opacity="0.5"/>
            <path d="M9 13.5L12 9.5L15 13.5V15H9V13.5Z" stroke="currentColor" strokeWidth="0.9" opacity="0.3"/>
          </svg>
        </a>

        <div className="site-menu" ref={menuRef}>
          <button
            type="button"
            className={`site-menu-toggle ${isMenuOpen ? 'is-open' : ''}`}
            onClick={() => setIsMenuOpen((open) => !open)}
            aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-expanded={isMenuOpen}
            aria-controls="site-navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav
            id="site-navigation"
            className={`site-dropdown ${isMenuOpen ? 'is-open' : ''}`}
            aria-hidden={!isMenuOpen}
          >
            <a href="/" onClick={handleNavClick}>Home</a>
            <a href="/software" onClick={handleNavClick}>Software</a>
            <a href="/physical-computing" onClick={handleNavClick}>Physical Computing</a>
            <a href="/installations" onClick={handleNavClick}>Installations</a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
